"use client";

import { Card, CardBody, CardHeader } from "@heroui/react";
import { IconBriefcase2, IconTarget } from "@tabler/icons-react";
import ActiveProjects from "../ActiveProjects";
import Missoes from "../Missoes";

export default function ActiveProjectsList() {
  return (
    <div className="flex flex-col md:flex-row gap-6">
      <div className="w-full md:w-3/4">
        <Card className="p-5 gap-3">
          <CardHeader className="flex flex-row items-center gap-2">
            <div className="rounded-full bg-emerald-500/10 p-2 flex items-center justify-center">
              <IconBriefcase2 size={22} className="text-emerald-500" />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold">Projetos Ativos</h1>
          </CardHeader>

          <div className="flex flex-col justify-center items-center">
            <ActiveProjects />
          </div>
        </Card>
      </div>

      <div className="w-full md:w-1/4">
        <Card className="p-5">
          <CardHeader className="flex gap-2 justify-start items-center">
            <div className="rounded-full bg-emerald-500/10 p-2 flex items-center justify-center">
              <IconTarget size={22} className="text-emerald-500" />
            </div>
            <h2 className="text-xl font-bold">Missões rápidas</h2>
          </CardHeader>
          <CardBody className="flex gap-2">
            <Missoes />
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
